<script>
import { mapState } from 'vuex'
import { getSizeWithUnit } from '@/utils/size'
import Header from '@/components-v4/header.vue'
import Footer from '@/components-v4/footer.vue'

export default {
  name: 'TamaraLayoutV4',
  components: { Header, Footer },
  props: {
    hideHeader: Proptypes.boolean(false),
    hideFooter: Proptypes.boolean(false),
    hideCancelButton: Proptypes.boolean(false),
    hideFooterLogo: Proptypes.boolean(false),
    displaySwitchLanguage: Proptypes.boolean(false),
    displayBackButton: Proptypes.boolean(false),
    disabledCancelButton: Proptypes.boolean(false),
    disabledBackButton: Proptypes.boolean(false),
    showBottomBackground: Proptypes.boolean(false),
    stage: Proptypes.string(''),
  },
  computed: {
    ...mapState('application', ['redirecting', 'screenHeight']),
    containerClass() {
      const classes = ['overflow-hidden tamara-base-layout']

      if (this.hideFooter) {
        classes.push('tamara-base-layout--without-footer')
      }

      if (this.showBottomBackground) {
        classes.push('tamara-base-layout--has-bottom-bg')
      }

      return classes
    },
    minHeight() {
      return getSizeWithUnit(this.screenHeight, '100vh')
    },
  },
}
</script>

<template>
  <v-card
    :class="containerClass"
    elevation="0"
    :style="`min-height: ${minHeight} !important;`"
  >
    <slot v-if="!hideHeader" name="header">
      <Header
        :hide-cancel-button="hideCancelButton"
        :display-back-button="displayBackButton"
        :disabled-back-button="disabledBackButton"
        :disabled-cancel-button="disabledCancelButton"
        :stage="stage"
        @on-back="$emit('on-back', $event)"
      />
    </slot>
    <slot :hide-header="hideHeader" />
    <slot v-if="!hideFooter" name="footer">
      <Footer
        :switch-language="displaySwitchLanguage"
        :hide-logo="hideFooterLogo"
      />
    </slot>
  </v-card>
</template>

<style lang="scss" scope>
@import '@/styles/responsive.scss';

.tamara-base-layout {
  width: 100%;
  background-image: url('../../assets-v4/background.svg?url');
  background-position: top right;
  background-size: contain;
  min-width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;

  &--has-bottom-bg {
    background-size: cover;
    background-image: url('../../assets-v4/background-gradient-full-mobile.svg?url');
    background-position: top left;
  }
}

@include for-md-up {
  .tamara-base-layout {
    background-size: cover;
    background-position: top left;
    background-image: url('../../assets-v4/background-gradient-full-desktop-2.svg?url');

    &--has-bottom-bg {
      background-image: url('../../assets-v4/background-gradient-full-desktop.svg?url');
      background-position: top left;
    }
  }
}
</style>
